var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.582,
    cy: 18.2167,
    r: 17.5351,
    fill: "#FFF5D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.204 10.4668H12.1518C11.7745 10.4668 11.4688 10.7726 11.4688 11.1498C11.4688 13.3235 12.3323 15.4082 13.8693 16.9453L14.8637 17.9397C14.9624 18.0384 15.0118 18.0878 15.0471 18.1352C15.2628 18.4244 15.2628 18.8209 15.0471 19.1101C15.0118 19.1576 14.9624 19.2069 14.8637 19.3057L13.8693 20.3C12.3323 21.8371 11.4688 23.9218 11.4688 26.0955C11.4688 26.4727 11.7745 26.7785 12.1518 26.7785H22.204C22.5812 26.7785 22.887 26.4727 22.887 26.0955C22.887 23.9218 22.0234 21.8371 20.4864 20.3L19.492 19.3057C19.3933 19.2069 19.3439 19.1576 19.3086 19.1101C19.0929 18.8209 19.0929 18.4244 19.3086 18.1352C19.3439 18.0878 19.3933 18.0384 19.492 17.9397L20.4864 16.9453C22.0234 15.4082 22.887 13.3235 22.887 11.1498C22.887 10.7726 22.5812 10.4668 22.204 10.4668Z",
    stroke: "#0B0B0B",
    strokeWidth: 1.63117,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.f3b81f164a5c0b24dfd17876d1461663.svg";
export { ForwardRef as ReactComponent };